import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LiftService } from '../../services/lift.service';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { LiftModuleList } from '../../models/lift-module-list.model';
import { HttpResponse } from '@angular/common/http';
import { LookupDetail } from 'src/app/core/models/lookup-detail.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { NotificationType } from 'src/app/core/models/ui-notification.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-lift',
  templateUrl: './create-lift.component.html',
  styleUrls: ['./create-lift.component.css']
})
export class CreateLiftComponent implements OnInit {
  form = new FormGroup({});
  modules: LiftModuleList[] = [];
  liftEngines: LookupDetail[] = [];
  liftTypes: LookupDetail[] = [];
  liftBoards: LookupDetail[] = [];
  selectedCompany: number;
  moduleError = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private liftService: LiftService,
    private entityListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    const response: HttpResponse<LiftModuleList[]> = this.route.snapshot.data.modules;
    this.modules = response.body;

    const response2: HttpResponse<LookupDetail[]> = this.route.snapshot.data.liftEngines;
    this.liftEngines = response2.body;

    const response3: HttpResponse<LookupDetail[]> = this.route.snapshot.data.liftTypes;
    this.liftTypes = response3.body;

    const response4: HttpResponse<LookupDetail[]> = this.route.snapshot.data.liftBoards;
    this.liftBoards = response4.body;

    this.form.addControl('module', new FormControl(''));

    this.selectedCompany = +localStorage.getItem('selectedCompany');

    this.form.addControl('address', new FormGroup({
      street: new FormControl('', Validators.required),
      town: new FormControl('', Validators.required),
      zipcode: new FormControl('', [Validators.required, Validators.minLength(5)]),
      country: new FormControl('CZ', Validators.required)
    }));

    this.form.addControl('lift', new FormGroup({
      description: new FormControl(''),
      floorCount: new FormControl('', Validators.required),
      loadCapacity: new FormControl('', Validators.required),
      liftEngine: new FormControl(1, Validators.required),
      liftType: new FormControl(1, Validators.required),
      liftBoard: new FormControl(1, Validators.required)
    }));
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 1 ? []
        : this.modules.filter(v => v.code.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )

  formatter = (x: { code: string }) => x.code;

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {
    if (!this.form.get('module').value.code) {
      this.moduleError = this.translateService.instant('liftDetail.noModuleNotification');
      return;
    }

    if (this.form.valid) {
      this.liftService.create({
        liftModuleId: this.form.get('module').value.id,
        companyId: this.selectedCompany,
        liftTypeId: this.form.get('lift.liftType').value,
        liftEngineId: this.form.get('lift.liftEngine').value,
        liftBoardId: this.form.get('lift.liftEngine').value,
        description: this.form.get('lift.description').value,
        floorCount: this.form.get('lift.floorCount').value,
        isActive: true,
        loadCapacity: this.form.get('lift.loadCapacity').value,
        liftAddress: {
          id: null,
          street: this.form.get('address.street').value,
          town: this.form.get('address.town').value,
          country: this.form.get('address.country').value,
          zipCode: this.form.get('address.zipcode').value
        }
      })
      .subscribe(() => {
        this.entityListRefresh.refresh('lift');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: this.translateService.instant('liftDetail.createNotification')
        });
        modal.closeModal(null);
        },
        err => {
          const errorMessage = err.error.Message;
          if (errorMessage.includes('lift_lift_module_id')) {
            this.moduleError = this.translateService.instant('liftDetail.moduleDuplicationNotification');
          }
        });
    }
  }
}
